<ng-container *ngIf="column">
  <miq-year-picker
    #input
    [id]="column.colId"
    [placeholder]="placeholder"
    [date]="currentValue"
    [minDate]="minDate"
    [maxDate]="maxDate"
    [allowPaste]="allowPaste"
    (selectionChange)="onYearSelected($event)"
    (paste)="onPaste($event)"
    (input)="onInput($event)"
  ></miq-year-picker>
</ng-container>
